// /**
//  * App Configurations
//  */
// const url = "http://localhost:8001",

//   apiUrlStaging = "https://www.staging-back.medsurlink.com",
//   apiUrlProd = "https://www.back.medsurlink.com",
//   teleconsultationUrlLocal = "http://localhost:8081",
//   teleconsultationUrlStaging = "https://staging-teleconsultations.medsurlink.com",
//   teleconsultationUrlProd = "https://teleconsultations.medsurlink.com",
//   socketlocal = "http://127.0.0.1:3000",
//   socketStaging = "https://staging-notifications.medsurlink.com",
//   socketProd = "https://notifications.medsurlink.com",
//   socket = socketlocal,
//   apiUrl = apiUrlProd,
//   teleconsultationUrl = teleconsultationUrlLocal,
//   dureeVocal = 180, // 3 minutes,
//   stripe_test_key = "pk_test_51HfRm5AB7Hl5NGXslQo4Ob0M1SjOaajHHMniXI7e740gWFeiQcYlqS8VhNN2Jy5Mifvhxp7Y40Wh7K025A2sXWAi00EKcKTGcR",
//   stripe_live_key = "pk_live_51Hf6FLJRvANUAsFaJCdg8V6CkkhClwXTZDGKqk7AsNUgOfIxGHyRkv2t1bnIfS61iTjIP2OIZk18W99hA0sJcCVh00R9zr6xr7",
//   stripe_live = stripe_test_key;

// export default {
//   brandName: "Medsurlink App",
//   baseUrl: 'https://' + window.location.hostname,
//   apiUrl: `${apiUrl}/api`,
//   imgUrl: `${apiUrl}`,
//   teleconsultationUrl: `${teleconsultationUrl}`,
//   socket: socket,
//   dureeVocal: dureeVocal,
//   paymentUrl: "https://www.medicasure.com/",
//   brandLogo: "/images/logo-medicasure-blanc.png",
//   backgroundImg: "/img/header-bg.jpg",
//   appClientId: 2,
//   appClientSecret: "EgDwYss1HthxUbAjbRViO0QaNF82gsJIyCiKXiZr",
//   tinyMceKey:"fvd0yrrjf9ic04brjzm9pre7cz0j6fwz5jylnjsvay8kajua",
//   stripe_key: stripe_live
// };

/**
 * App Configurations
 */
const url = "http://192.168.1.114:8000",
  apiUrlStaging = "https://www.staging-back.medsurlink.com",
  apiUrlProd = "https://www.back.medsurlink.com",
  teleconsultationUrlLocal = "http://localhost:8081",
  teleconsultationUrlStaging =
    "https://staging-teleconsultations.medsurlink.com",
  teleconsultationUrlProd = "https://teleconsultations.medsurlink.com",
  socketlocal = "http://127.0.0.1:3000",
  socketStaging = "https://staging-notifications.medsurlink.com",
  socketProd = "https://notifications.medsurlink.com",
  socket = socketProd,
  apiUrl = apiUrlProd,
  teleconsultationUrl = teleconsultationUrlProd,
  dureeVocal = 180, // 3 minutes
  stripe_test_key =
    "pk_test_51HfRm5AB7Hl5NGXslQo4Ob0M1SjOaajHHMniXI7e740gWFeiQcYlqS8VhNN2Jy5Mifvhxp7Y40Wh7K025A2sXWAi00EKcKTGcR",
  stripe_live_key =
    "pk_live_51Hf6FLJRvANUAsFaJCdg8V6CkkhClwXTZDGKqk7AsNUgOfIxGHyRkv2t1bnIfS61iTjIP2OIZk18W99hA0sJcCVh00R9zr6xr7",
  stripe_live = stripe_live_key;
export default {
  brandName: "Medsurlink App",
  baseUrl: "https://" + window.location.hostname,
  apiUrl: `${apiUrl}/api`,
  imgUrl: `${apiUrl}`,
  teleconsultationUrl: `${teleconsultationUrl}`,
  socket: socket,
  dureeVocal: dureeVocal,
  paymentUrl: "https://www.medicasure.com/",
  brandLogo: "/images/logo-medicasure-blanc.png",
  backgroundImg: "/img/header-bg.jpg",
  appClientId: 2,
  appClientSecret: "EgDwYss1HthxUbAjbRViO0QaNF82gsJIyCiKXiZr",
  tinyMceKey: "fvd0yrrjf9ic04brjzm9pre7cz0j6fwz5jylnjsvay8kajua",
  stripe_key: stripe_live,
};
